import { css, html, LitElement } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';

class D1iMapWrapper extends LitElement {
  static get is() { return 'd1i-map-wrapper'; }

  static get styles() {
    return css`
    .d1i-map__map {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
    }

    toujou-map-popup {
      width: auto;
    }

    .popup {
      text-decoration: none;
      padding: 10px 10px 15px;
    }

    .popup__title {
      text-decoration: none;
      color: var(--primary-color);
      margin: 0.5rem;
      text-align: center;
    }
  `;
  }

  static get properties() {
    return {
      accessToken: {
        type: String,
        attribute: 'access-token',
      },
      reducedMotion: {
        type: Boolean,
        attribute: 'reduced-motion',
      },
      mapStyle: {
        type: String,
        attribute: 'map-style',
      },
      initialBounds: {
        type: Array,
        attribute: 'initial-bounds',
      },
      zoom: {
        type: Number,
      },
      center: {
        type: Array,
      },

      _map: { state: true },
      _popupFeature: { state: true },
      _popupCoordinates: { state: true },
    };
  }

  constructor() {
    super();
    this._map = null;
    this._popupFeature = null;
    this._popupCoordinates = null;
    this.initialBounds = null;
    this.zoom = null;
    this.center = null;
    this.reducedMotion = false;
  }

  render() {
    return html`
      <toujou-map
          class="d1i-map__map"
          @toujou-map-ready="${this._registerEventListeners}"
          access-token="${this.accessToken}"
          ?reduced-motion="${this.reducedMotion}"
          initial-bounds=${ifDefined(this.initialBounds ? JSON.stringify(this.initialBounds) : undefined)}
          zoom="${this.zoom}"
          center=${ifDefined(this.center ? JSON.stringify(this.center) : undefined)}
          map-style="${this.mapStyle}"
          interactive
          fullscreen-control
      >
        <slot></slot>
        ${this._popupFeature && this._popupCoordinates ? html`
          <toujou-map-popup
            @toujou-map-popup-closed="${this._onPopupClose}"
            .coordinates="${this._popupCoordinates}"
            close-button
            close-on-outside-click
          >
            ${this._renderPopupContent()}
          </toujou-map-popup>`
    : ''
}
      </toujou-map>
    `;
  }

  _registerEventListeners(event) {
    this._map = event.detail;
    this._map.on('click', (mapClickEvent) => {
      const clickedFeature = this._map.queryRenderedFeatures(mapClickEvent.point)[0];

      if (!clickedFeature) {
        return;
      }

      if (['related-geojson', 'spiderfy'].includes(clickedFeature.source) === false) {
        return;
      }

      if (/cluster/.test(clickedFeature.layer.id)) {
        return;
      }
      this._popupCoordinates = mapClickEvent.lngLat;
      this._popupFeature = clickedFeature;
    });

    this._map.on('mousemove', (mouseMoveEvent) => {
      const hoveredFeature = this._map.queryRenderedFeatures(mouseMoveEvent.point)[0];
      if (hoveredFeature && (['related-geojson', 'spiderfy'].includes(hoveredFeature.source))) {
        this._map.getCanvas().style.cursor = 'pointer';
      } else {
        this._map.getCanvas().style.cursor = '';
      }
    });
  }

  _renderPopupContent() {
    return html`
      <a class="popup"
         href="${this._popupFeature.properties?.external_link ?? this._popupFeature.properties.url}"
         target="${this._popupFeature.properties?.external_link ? '_blank' : '_self'}"
      >
        <div class="popup__infos">
          <h3 class="popup__title">${this._popupFeature.properties.title}</h3>
        </div>
      </a>
    `;
  }

  _onPopupClose() {
    this._popupFeature = null;
    this._popupCoordinates = null;
  }
}
customElements.define(D1iMapWrapper.is, D1iMapWrapper);
